<!--
@name 博士教育-人工智能应用与博士专业
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">项目简介</div>
        <div class="selector-indent">
          人工智能应用与管理博士专业致力于培养兼具技术前瞻性、商业重构力与全球治理视野以及战略管理思维的复合型领导者，聚焦于AI技术在企业决策、产业升级、社会治理等场景中的系统性整合与风险管控，AI伦理治理及产业创新生态构建。
        </div>
        <div class="selector-indent">
          此专业诞生于AI技术从实验室走向大规模产业化的临界点，旨在解决“技术可用性”与“商业可用性”之间的断层，培养能够将技术潜力转化为真实价值、并在伦理与商业间建立可持续桥梁的跨界领导者。
        </div>
        <div class="advantage">
          <p class="advantage-title">跨学科深度融合，构建复合型知识体系</p>
          <p>
            课程整合商科管理、人工智能技术、人文伦理三大维度，覆盖宏观经济、企业战略、数字化转型、AI治理等前沿议题，培养既懂技术应用又擅管理的复合型人才。</p>
          <p class="advantage-title">线上+线下混合式教学模式</p>
          <p>
            适配多元需求，根据个人时间安排，自主选择线上或线下学习方式，兼顾系统性与灵活性。除了课程学习之外，学院会组织企业参访、高管工作坊、数字化转型实战演练，将理论转化为行业解决方案，强化实战能力。</p>
          <p class="advantage-title">强大的校友网络和资源平台</p>
          <p>
            强校友资源加持，优质的资源平台（近万名全球校友网络，与优秀同窗一起前行)，搭建高端商务交流，链接专家智库、金融机构等资源。</p>
          <p class="advantage-title">中外高校联合培养</p>
          <p>古老的法国高等学府与中国一流的大学师资及业内专家强强联合，共同参与教学指导。</p>
          <p class="advantage-title">卓越资质</p>
          <p>AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。</p>
          <p class="advantage-title">课程严谨</p>
          <p>遵循国际商学院协会(AACSB)标准设置课程，引入国际先进管理理念教材，依托经典案例分析，深化知识体系。</p>
        </div>
      </div>
      <!--  专业介绍 -->
      <!-- 项目优势 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程设计</div>
        <img src="@/assets/images/personRain/darm-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">部分师资</div>
        <p>杨禹：中国发展改革报社副社长、央视著名评论员。</p>
        <p>
          郁俊莉：北京大学教授、博士生导师，北京大学中国新兴产业创新研究中心主任、国家社科基金评审专家、教育部学位论文评审专家、广东省发改委学术委员、中华全国工商联合会企业教育导师。</p>
        <p>
          周旺生：北京大学教授（A级)，国家重点学科法学理论专业博士生导师，北京大学立法学研究中心主任，《立法研究》主编。兼任中国法理学会副会长，中国立法学会副会长。</p>
        <p>
          姜正新：经济学博士、教授，曾任职中国联通集团有限公司副总经理，党组成员。现任法国布雷斯特高等商学院中国区负责人，伟东云教育集团副董事长。</p>
        <p>
          张延：北京大学经济学院教授，宏观经济学专业博士生导师，北京大学精品课程主讲人，国内外数十所著名高校DBA授课专家，在北京大学经济学院分别获得了经济学学士学位、国际金融硕士学位、西方经济学博士学位。</p>
        <p>王超：北京大学国家发展研究院教授，清华大学公益慈善研究院资深研究员，曾任清华大学公益慈善研究院执行院长。《中国非营利评论》编委，《中国大百科全书》非营利组织管理部副主编，清华-MIT
          IDEAS领导力计划首席教授。</p>
        <p>
          张玉杰：清华大学经济管理学院博士后，教授，中共中央党校（国家行政学院)经济学教研部教授，博士生导师。国务院国资委对标世界一流企业研究项目首席科学家。</p>
        <p>
          杜军：布雷斯特商学院高等商学院教授，北京大学客座教授，原日本NEC公司中国研究院院长，浙江北大信息技术高等研究院院长顾问。</p>
        <p>
          吕本富：中国科学院大学教授、博士生导师。中国科学院大学网络经济和知识管理研究中心主任，国家创新与发展战略研究会副会长。著名数字经济专家。</p>
        <p>
          陈文君：经济学博士，中欧陆家嘴金融50人，上海高校张江协同创新研究院副院长，上海人工智能协会副秘书长，数字经济研究中心主任，并因法律科技的创新受到表彰，担任多家大型机构顾问、独立董事和地方政府智库等职。</p>
        <p>
          韩迎娣：北京大学经济学院EMBA特聘讲师，黑马创业学院实验室级专家导师，中国生产力促进中心协会数字经济委员会特约专家。</p>
        <p>Mériadec Le
          Mouillour：海事功勋骑士勋章获得者/前西布列塔尼工商会总经理/法国港口联盟副主席、高级海事委员会成员和欧洲海港组织执行委员会成员。</p>
        <p>Bertrand
          PAUGET：布雷斯特高等商学院教授，研究专长涵盖组织创新、未来研究(foresight)、知识管理与健康系统转型现任教务长兼研究院院长。</p>
        <p>Dominique MAZÉ：布雷斯特高等商学院教授，国际战略与跨文化管理方向，EMBA项目主管。</p>
        <p>Houssem
          CHEMINGUI：布雷斯特高等商学院副教授，研究信息系统与数据工程方向，在人工智能与软件工程融合领域拥有前沿成果。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 学习安排 -->
      <div class="cont-item">
        <div class="advantage">
          <div class="title-image">学习安排</div>
          <p class="advantage-title">项目学制</p>
          <p>该项目教学共分三个阶段，学制共三年。</p>
          <p>1. 15门核心课程学习（每月一门) ；</p>
          <p>2. 修完课程学分完成相应作业后进行论文写作； </p>
          <p>3. 论文答辩通过后，获得校本部颁发的文凭。 </p>
        </div>
      </div>
      <!-- 学习安排 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>
          具有硕士学位或研究生毕业证书或研究生同等学历结业证书，学科专业不限；同时具有十年以上工作经验和五年以上管理经验的行业龙头企事业董事长、总经理或高级管理者。</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.申请表（中英文）各一份</p>
          <p class="apply-text">2.个人履历（中英文）各一份</p>
          <p class="apply-text">3.最高学历证书原件或复印件及英文翻译件</p>
          <p class="apply-text">4.认证过的毕业证复印件或学信网认证报告</p>
          <p class="apply-text">5.身份证复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片4张和电子版</p>
          <p class="apply-text">7.名片4张</p>
          <p class="apply-text">8.中文推荐信1封</p>
          <p class="apply-text">9.就职公司简介（中文即可)一份</p>
        </div>
        <!--申请材料-->
        <!-- 培养方式 -->
        <div class="cont-item">
          <div class="title-image">录取机制</div>
          <p>实行“面试+推荐”双模式入学制。综合考量申请者的基本素质、教育背景、工作经验、研习能力、战略远见等，择优录取。</p>
        </div>
        <!-- 培养方式 -->
        <!-- 学费标准 -->
        <div class="cont-item">
          <div class="title-image">学费标准</div>
          <p>含注册费、授课费、教学管理费、学位证书费等费用。</p>
          <p>上课期间交通、食宿及国内外参访游学等费用自理。</p>
        </div>
        <!-- 学费标准 -->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">人工智能应用与管理博士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->

  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'EduDarmVue',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/F0/wKgCEmgHWUeABTqCAYCPgwX9QdE846.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduDarmVue.vue